/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataStructureGraphIcon32Regular = forwardRef('DataStructureGraphIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 8.5A5.5 5.5 0 0 1 7.5 3h11a5.5 5.5 0 1 1 0 11h-2.861l3.322 4H24.5a5.5 5.5 0 1 1 0 11h-11a5.5 5.5 0 1 1 0-11h2.861l-3.322-4H7.5A5.5 5.5 0 0 1 2 8.5ZM7.5 5a3.5 3.5 0 1 0 0 7h11a3.5 3.5 0 1 0 0-7h-11Zm6 15a3.5 3.5 0 1 0 0 7h11a3.5 3.5 0 1 0 0-7h-11Z" })));
});
